import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import { priceSummaryAsync } from "./pricesummary.async";

const initialState = {
  getPriceSummaryLoader: false,
  getPriceSummary: [],
};

export const priecSummarySlice = createSlice({
  name: "priceSummary",
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(priceSummaryAsync.pending), (state) => {
      state.getPriceSummaryLoader = true;
    });
    builder.addMatcher(
      isAnyOf(priceSummaryAsync.fulfilled),
      (state, action) => {
        state.getPriceSummaryLoader = false;
        state.getPriceSummary = action.payload.data;
      },
    );
    builder.addMatcher(isAnyOf(priceSummaryAsync.rejected), (state, action) => {
      state.getPriceSummaryLoader = false;
    });
  },
});

export default priecSummarySlice.reducer;
